/* Clinic inquiry form ("which service or practitioner is right for me?").
   With the form relay configured (theme setting shared with careers and
   insurance), the fields post to the Apps Script relay, which emails the clinic
   inbox with reply-to set to the client. Without it, or if the relay fails, the
   native Shopify contact form submits so no inquiry is ever lost. */
(function () {
  function init() {
    var wrap = document.querySelector('[data-clinic-wrap]');
    if (!wrap) return;
    var form = wrap.querySelector('form');
    if (!form) return;

    var endpoint = wrap.getAttribute('data-upload-url');
    var errorEl = wrap.querySelector('[data-cq-error]');
    var successEl = wrap.querySelector('[data-cq-success]');
    var submitBtn = wrap.querySelector('[data-cq-submit]');
    var fellBack = false;

    form.addEventListener('submit', function (e) {
      if (!endpoint || fellBack) return; // native contact form path

      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';

      var val = function (sel) { return (wrap.querySelector(sel) || {}).value || ''; };
      var returning = wrap.querySelector('[data-cq-returning]:checked');
      var payload = {
        kind: 'clinic',
        recipient: wrap.getAttribute('data-recipient') || '',
        name: val('[data-cq-name]'),
        email: val('[data-cq-email]'),
        phone: val('[data-cq-phone]'),
        replyBy: val('[data-cq-replyby]'),
        returning: returning ? returning.value : '',
        concern: val('[data-cq-concern]'),
        note: val('[data-cq-note]'),
        page: window.location.href
      };

      // text/plain keeps this a "simple" request (no CORS preflight, which
      // Apps Script web apps cannot answer)
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
        .then(function (d) {
          if (d && (d.ok || d.result === 'ok')) {
            form.hidden = true;
            if (successEl) {
              successEl.hidden = false;
              successEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          } else {
            throw new Error((d && d.error) || 'Relay failed');
          }
        })
        .catch(function () {
          // relay unavailable (or not yet updated for clinic inquiries) — fall
          // back to the native contact form so the inquiry still arrives
          fellBack = true;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send my inquiry';
          form.submit();
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
